import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import RadioBoxT from '@/Controls/RadioBox';

export default class RadioBoxBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.radioBox = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let RadioBox = ComponentManager.getControl<typeof RadioBoxT>('RadioBox');
                let group = $(element);
                let options = valueAccessor();
                let items = options.items();

                options.parent.elements = [];

                for (let i = 0; i < items.length; i++) {
                    let radioBox = new RadioBox(items[i], $('<div><input type="radio"></div>').appendTo(group));
                    let tuple = radioBox.getTuple();

                    options.parent.elements.push(radioBox);
                }
            }
        };
    }
}